import * as React from 'react';
import * as moment from 'moment';
import { __ } from 'react-i18n';
import { IconType } from '../components/Zemplin/General/SvgIcon';

export const getSymbolFromCurrency = (currency: string): string => {
  switch (currency) {
    case 'EUR':
      return '€';

    default:
      return '€';
  }
};

export const getCountryFromId = (country: string): string => {
  switch (country) {
    case 'sk':
      return 'Slovensko';

    default:
      return 'Slovensko';
  }
};

export const getDeliveryInfoFromAddress = (
  id: number,
  addresses: any[],
): any => {
  const address = addresses.filter(a => a.id.toString() === id.toString());
  return address[0];
};

export const formatPrice = (
  price: number,
  currency: string,
  decimalPlaces: number = 2,
  zeroPriceText: boolean = false,
) => {
  let priceValue: string;

  if (Number.isInteger(price)) {
    priceValue = `${price},${'0'.repeat(decimalPlaces)}`;
  } else {
    priceValue = price.toFixed(decimalPlaces).replace('.', ',');
  }

  if (zeroPriceText && price === 0) {
    return __('ZADARMO');
  }

  switch (currency) {
    case 'EUR':
      return (
        <>
          {priceValue}
          &nbsp;€
        </>
      );
    default:
      return priceValue;
  }
};

export const formatPriceToString = (price: any, currency: string = 'EUR') => {
  const value = round(parseFloat(price), 2);

  if (Number.isInteger(value)) {
    return `${value},${'0'.repeat(2)} ${getSymbolFromCurrency(currency)}`;
  } else {
    const strValue = value.toString().replace('.', ',');
    const splitNumber = strValue.split(',');

    if (splitNumber.length === 1) {
      return price;
    }

    while (splitNumber[1].length < 2) {
      splitNumber[1] += '0';
    }
    return `${splitNumber[0]},${splitNumber[1]} ${getSymbolFromCurrency(
      currency,
    )}`;
  }
};

export const checkMetaTag = tag => {
  const defaultMetaTag = 'Zemplin.sk';
  if (typeof tag === 'string') {
    if (tag.includes('Zemplin.sk')) {
      return tag;
    } else {
      return `${tag} | ${defaultMetaTag}`;
    }
  } else {
    return '';
  }
};

export const prop = (object, path, defaultValue: any = null) => {
  const val = path.split('.').reduce((o, x) => {
    return typeof o === 'undefined' || o === null ? defaultValue : o[x];
  }, object);
  if (typeof val === 'undefined') {
    return defaultValue;
  }
  return val;
};

export const emailIsValid = email => {
  const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return email.length > 0 && emailRegex.test(email.toLowerCase());
};

export const formatDate = (
  date: Date,
  format: string = 'YYYY-MM-DD HH:mm:ss',
): string => {
  return moment(date).format(format);
};

export const getRequestColor = (status, theme): string => {
  switch (status) {
    case 'WAITING':
      return theme.colors.placeholder;

    case 'INPROGRESS':
      return theme.colors.primary;

    case 'DONE':
      return theme.colors.stockCountAvailable;

    default:
      return theme.colors.placeholder;
  }
};

export const getRequestIcon = (status): IconType => {
  switch (status) {
    case 'WAITING':
      return IconType.time;

    case 'INPROGRESS':
      return IconType.inwork;

    case 'DONE':
      return IconType.paid;

    default:
      return IconType.inwork;
  }
};

export const getOrderColor = (status, theme): string => {
  switch (status) {
    case 'Zrušená':
      return theme.infoTexts.colorError;

    case 'INPROGRESS':
      return theme.colors.primary;

    case 'DONE':
      return theme.colors.textPrimary;

    default:
      return theme.colors.textPrimary;
  }
};

export const arrayToObject = (array, key) =>
  array.reduce((obj, item) => {
    obj[item[key]] = item;
    return obj;
  }, {});

export const getImagePath = (
  baseUrl: string,
  filename,
  { width, height } = { width: 64, height: 80 },
  noSize = false,
  webp = false,
  typeCover = false,
) => {
  if (height === 0) {
    return `${baseUrl}/image?query=${filename}&width=${width}&webp=${
      webp ? 1 : 0
    }${typeCover ? '&type=cover' : ''}`;
  }

  return noSize
    ? `${baseUrl}/image?query=${filename}&webp=${webp ? 1 : 0}${
        typeCover ? '&type=cover' : ''
      }`
    : `${baseUrl}/image?query=${filename}&width=${width}&height=${height}&webp=${
        webp ? 1 : 0
      }${typeCover ? '&type=cover' : ''}`;
};

export function getImagePathNew(
  filename,
  { width, height } = { width: 64, height: 80 },
  noSize = false,
  webp = false,
  typeCover = false,
) {
  if (height === 0) {
    return `${
      process.env.REACT_APP_API_BASE_URL
    }/image?query=${filename}&width=${width}&webp=${webp ? 1 : 0}${
      typeCover ? '&type=cover' : ''
    }`;
  }

  return noSize
    ? `${process.env.REACT_APP_API_BASE_URL}/image?query=${filename}&webp=${
        webp ? 1 : 0
      }${typeCover ? '&type=cover' : ''}`
    : `${
        process.env.REACT_APP_API_BASE_URL
      }/image?query=${filename}&width=${width}&height=${height}&webp=${
        webp ? 1 : 0
      }${typeCover ? '&type=cover' : ''}`;
}

export const round = (num, precision): number => {
  const factor = 10 ** precision;
  const tempNumber = num * factor;
  const roundedTempNumber = Math.round(tempNumber);
  return roundedTempNumber / factor;
};
